import { ChainId } from 'vvs-sdk'
import { getTokens } from './tokens'

/**
 * TOKEN_PRICE_MAPPING are used to map a price of token to another
 * i.e. xARGO is the same price as ARGO, then we can use ARGO price for xARGO price
 *
 * there is a config file for the same purpose in vvs-info-api:
 * packages/vvs-info-api/src/shared/tokenPriceMappings.ts
 */

const tokenList = getTokens()

const getTokenPriceMapping = (): Record<string, string> => {
  if (process.env.REACT_APP_CHAIN_ID === ChainId.MAINNET.toString()) {
    // MAINNET_TOKEN_PRICE_MAPPING
    return Object.fromEntries(
      Object.entries({
        [tokenList.xargo.address]: tokenList.argo.address,
        [tokenList.stardust.address]: tokenList.gold.address,
      }).map(([tokenAddr, priceFromTokenAddr]) => [tokenAddr.toLowerCase(), priceFromTokenAddr.toLowerCase()]),
    )
  }

  // TESTNET_TOKEN_PRICE_MAPPING
  return Object.fromEntries(
    Object.entries({
      [tokenList.xrose1.address]: tokenList.cro.address,
    }).map(([tokenAddr, priceFromTokenAddr]) => [tokenAddr.toLowerCase(), priceFromTokenAddr.toLowerCase()]),
  )
}

export const TOKEN_PRICE_MAPPING: Record<string, string> = getTokenPriceMapping()

export default TOKEN_PRICE_MAPPING
